import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    locked: false,
    showSpinner: false,
    initial: true,
    searchTerm: '',
    fullResponse: {},
    resultsItems: [],
    resultsData: {},
    facets: {},
    activeFilters: [
      // {
      //   name: 'Supreme Court',
      //   shortname: 'supreme-court',
      //   filterId: 0,
      //   resultsCount: 6,
      //   kind: "topics",
      // },
    ],
    dateFilterFrom: '',
    dateFilterTo: '',
    newTypeCount: null,
    newTopicsCount: null,
    newCenturiesCount: null,
    currentPage: 1,
  },
  getters: {
    getSearchTerm: state => {
      return state.searchTerm
    },
    getCurrentPage: state => {
      return state.currentPage
    },
    getInitial: state => {
      return state.initial
    },
    getLocked: state => {
      return state.locked
    },
    getShowSpinner: state => {
      return state.showSpinner
    },
    getFullResponse: state => {
      return state.fullResponse
    },
    getResultsItems: state => {
      return state.resultsItems
    },
    getResultsData: state => {
      return state.resultsData
    },
    getActiveFilters: state => {
      return state.activeFilters
    },
    getDateFilterFrom: state => {
      return state.dateFilterFrom
    },
    getDateFilterTo: state => {
      return state.dateFilterTo
    },
    getFacets: state => {
      return state.facets
    },
    getNewTypeCount: state => {
      return state.newTypeCount
    },
    getNewTopicsCount: state => {
      return state.newTopicsCount
    },
    getNewCenturiesCount: state => {
      return state.newCenturiesCount
    },
  },
  mutations: {
    updateNewTypeCount(state, newCount) {
      state.newTypeCount = newCount;
    },
    updateNewTopicsCount(state, newCount) {
      state.newTopicsCount = newCount;
    },
    updateNewCenturiesCount(state, newCount) {
      state.newCenturiesCount = newCount;
    },
    updateSearchTerm(state, newTerm) {
      state.searchTerm = newTerm;
    },
    updateLocked(state, newState) {
      state.locked = newState;
      if (state.locked === false) {
        state.showSpinner = false;
      }
    },
    updateShowSpinner(state, newState) {
      state.showSpinner = newState;
    },
    updateCurrentPage(state, newState) {
      state.currentPage = newState;
    },
    updateInitial(state, newState) {
      state.initial = newState;
    },
    updateFullResponse(state, newResponse) {
      state.fullResponse = newResponse;
    },
    updateResultsItems(state, newItems) {
      state.resultsItems = newItems;
    },
    updateResultsData(state, newData) {
      state.resultsData = newData;
    },
    updateActiveFilters(state, newFilters) {
      state.activeFilters = newFilters;
    },
    updateDateFilterFrom(state, newDate) {
      if (typeof newDate === 'string' && newDate[0] !== '-') {
        state.dateFilterFrom = newDate
      } else {
        state.dateFilterFrom = ''
      }
    },
    updateDateFilterTo(state, newDate) {
      if (typeof newDate === 'string' && newDate[0] !== '-') {
        state.dateFilterTo = newDate
      } else {
        state.dateFilterTo = ''
      }
    },
    updateFacets(state, newFacets) {
      state.facets = newFacets;
    },
  },
  actions: {

  },
});
